import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.qnaauto');
import { OnInit, Input } from '@angular/core';

@Component({
    selector: 'wiz-component-qnaauto',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.qnaauto/view.scss */
/* src/app/component.qnaauto/view.scss: no such file or directory */`],
})
export class ComponentQnaautoComponent implements OnInit {
    @Input() title: any;

    public async ngOnInit() {
    }
}

export default ComponentQnaautoComponent;